import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { ApiurlsService } from '../../../services/api-urls/apiurls.service';
import { ApirequestService } from '../../../services/apirequest/apirequest.service';
import { UtilityService } from '../../../services/utilities/utilities.services';
import { MatDialog, MatPaginator, PageEvent, MatDialogRef } from '@angular/material';
import { ConfirmdialogComponent } from '../../common/dialog/confirmdialog.component';
import { KycApproveRejectComponent } from './kyc-approve-reject.component';
import { CommonService } from '../../../services/apiservices/common.service';

@Component({
  selector: 'hybse-admin-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class KycComponent implements OnInit {
  fadeInDown: any;
  kycList: any = [];
  showLoader: boolean = true;
  public status: number;
  public limit: number = 50;
  public count: number;
  public offset: number = 0;
  public search: string;
  public filterType: number;
  public errorMessage: string;
  public username: string;
  public docId: string;
  public selectedStatus: any[] = [
    { id: 1, name: "All" },
    { id: 3, name: "Approve" },
    { id: 4, name: "Pending" },
    { id: 5, name: "Reject" }
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  //sorting
  order: string = 'createAt';
  reverse: boolean = false;
  sortedCollection: any[];
  constructor(
    private _urls: ApiurlsService,
    private _api: ApirequestService,
    private _utils: UtilityService,
    private dialog: MatDialog
  ) {  }

  ngOnInit() {
    this.getKYCList();
  }

  getKYCList() {
    this.showLoader = true;
    let data = {
      offset: this.offset,
      limit: this.limit
    }
    if (this.search || this.filterType) {
      data['search'] = this.search;
      data['filterType'] = this.filterType;
    }
    this._api.fetchApiData(this._urls.KycListUrl, data).subscribe(
      (data: any) => {
        let resSucc = data.data;
        let resError = data.error;
        this.kycList = [];
        if (resSucc != '') {
          this.kycList = resSucc.kycList;
          this.count = resSucc.count;
        } else {
          this.kycList = [];
          this.errorMessage = resError.errorDescription;
        }
      },
      error => { },
      () => {
        this.showLoader = false;
      }
    );
  }

  public getStatus(status: number): void {
    this.filterType = status;
    this.getKYCList();
  }

  public doSomething(): void {
    if (!this.username && !this.docId) {
      this.filterType = undefined;
      this.search = undefined;
      this.getKYCList();
    }
  }

  public selectedSearch(type: string) {
    if (type === 'username') {
      this.filterType = 6;
      this.search = this.username;
    } else {
      this.filterType = 7;
      this.search = this.docId;
    }
    this.getKYCList();
  }

  public isApprove(data): void {
    const kmn = JSON.parse(data.kmnPayload);

    this.dialog.open(KycApproveRejectComponent, {
      width: "60%",
      height: "80%",
      data: { data: kmn }
    });
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    this.reverse ? this.filterType = 2 : this.filterType = 1;
    this.order = value;
    this.getKYCList();
  }

  public pagination(page): void {
    this.offset = page.pageIndex;
    this.limit = page.pageSize;
    this.getKYCList();
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/pages/kyc/kyc.component.ts